import {
  flip,
  offset,
  shift,
  size,
  type Middleware,
  type Placement,
} from '@floating-ui/react';

const VIEWPORT_EDGE_PADDING = 8;

export function isTopAnchoredPlacement(placement: Placement): boolean {
  return placement.startsWith('top');
}

export function buildEmojiButtonMiddleware(
  placement: Placement,
  mainAxisOffset = 10
): Middleware[] {
  const offsetMiddleware = offset(mainAxisOffset);
  const shiftMiddleware = shift({ padding: VIEWPORT_EDGE_PADDING });

  if (isTopAnchoredPlacement(placement)) {
    return [
      offsetMiddleware,
      size({
        padding: VIEWPORT_EDGE_PADDING,
        apply({ availableHeight, elements }) {
          const maxHeight = `${Math.max(availableHeight, 0)}px`;
          Object.assign(elements.floating.style, {
            maxHeight,
          });
          elements.floating.style.setProperty(
            '--emoji-picker-max-height',
            maxHeight
          );
        },
      }),
      shiftMiddleware,
    ];
  }

  return [
    offsetMiddleware,
    flip({ fallbackStrategy: 'initialPlacement' }),
    shiftMiddleware,
  ];
}
